<script>
import { parallax } from "@/mixins/parallax";
import { viewport } from "@/mixins/viewport";

export default {
  name: "ContentCover",
  mixins: [parallax, viewport],
  computed: {
    speeds() {
      return {
        cover: this.viewport.mobile ? -1.5 : -3,
        print: this.viewport.mobile ? -0.5 : -1
      };
    }
  }
};
</script>
<style lang="stylus" scoped>
@import "ContentCover"
</style>
